module.exports = __webpack_public_path__ + "static/media/download-music.e01141e2.svg";